import styled from 'styled-components';

import { UI_COLORS, WHITE } from '../../utils/colors';
import { media } from '../../utils/media';
import { TOOLTIP_MIN_WIDTH } from './tooltipElementTable.constants';

export const TooltipTableDataCell = styled.td`
  border-bottom: none;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;

  span {
    color: ${WHITE};
    text-align: center;
    width: 100%;
    display: inline-block;
    line-height: 14px;
    background-color: ${(p) => (p.color ? p.color : '#668597')};
    margin-top: 2px;
    font-size: 10px;
    padding: 0 5px;
  }
`;

export const TooltipElementTable = styled.table`
  margin-bottom: 0;
  width: 100%;
  min-width: ${TOOLTIP_MIN_WIDTH}px;
  max-width: 350px;

  ${media.mobile`
    max-width: 300px;
  `}

  tr {
    padding-bottom: 10px;
    color: ${UI_COLORS[2]};

    th {
      font-size: 8px;
      font-weight: 400;
      text-transform: uppercase;
      line-height: 12px;
      height: 18px;
      display: table-cell;
    }

    ${TooltipTableDataCell},
    th {
      padding: 0;

      :nth-child(1) {
        padding-right: 15px;
      }

      :nth-child(2) {
        text-align: center;
      }
    }
  }
`;
